'use client';

import { CookieKeys, getClientBooleanCookie } from '@finn/ui-utils';
import { useEffect, useState } from 'react';

export const ImpersonationIndicator = () => {
  const [isImpersonating, setIsImpersonating] = useState(false);

  useEffect(() => {
    // Check if impersonation cookie exists
    const impersonationActive = getClientBooleanCookie(
      CookieKeys.IMPERSONATION_ACTIVE
    );
    setIsImpersonating(impersonationActive);
  }, []);

  if (!isImpersonating) {
    return null;
  }

  return (
    <div className="fixed left-1 top-1 z-popover rounded-lg border border-red bg-red px-2 py-1 text-white shadow-lg">
      <div className="flex items-center gap-2">
        <div className="size-3 animate-pulse rounded-full bg-white" />
        <span className="body-12-semibold">Impersonating</span>
      </div>
    </div>
  );
};
